import Settings from './components';

export default {
  protected: true,
  path: '/settings',
  key: '/settings',
  exact: true,
  component: Settings,
};
